var _circle, _circle2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCookTopSensor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#F5F5F5"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#14B814",
  className: "cook-top-sensor_svg__sensor-connection-status"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "gray",
  className: "cook-top-sensor_svg__sensor-no-status"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 49.5,
  r: 7.5,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49 46 7 7M56 46l-7 7"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#003252",
  clipPath: "url(#cook-top-sensor_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M34 32.333a2.667 2.667 0 1 1 0 5.333 2.667 2.667 0 0 1 0-5.333M26 33a2 2 0 1 1 0 4 2 2 0 0 1 0-4M26 24.333a2.667 2.667 0 1 1 0 5.333 2.667 2.667 0 0 1 0-5.333M34 25a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M39.334 20.333c.736 0 1.333.597 1.333 1.334v18.666c0 .736-.597 1.334-1.334 1.334H20.668l-.137-.007a1.334 1.334 0 0 1-1.197-1.327V21.667c0-.69.525-1.259 1.197-1.327l.137-.007zm-18 19.334h17.333V22.333H21.334z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.339 17.457c.037-.26.385-.417.733-.29a4.07 4.07 0 0 1 2.416 2.425c.126.35-.03.699-.289.736s-.504-.149-.6-.409a3.1 3.1 0 0 0-1.853-1.86c-.26-.096-.444-.342-.407-.602M40.309 15.025a6.36 6.36 0 0 1 4.33 4.343c.096.32-.067.633-.326.685-.26.052-.511-.142-.593-.416a5.42 5.42 0 0 0-3.685-3.698c-.267-.075-.46-.328-.415-.595l.008.007c.044-.252.355-.415.68-.327"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cook-top-sensor_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14 13.664h32v32H14z"
})))));
export default SvgCookTopSensor;